import React from "react";
import { useSettings } from "@/App";
import { Reveal, Eyebrow } from "@/components/Reveal";

const TITLES = { privacy: "Privacy Policy", terms: "Terms of Service", complaints: "Complaints Procedure" };

function render(text) {
  if (!text) return null;
  const lines = text.split("\n");
  const out = [];
  lines.forEach((line, i) => {
    const l = line.trim();
    if (!l) return;
    if (l.startsWith("### ")) out.push(<h3 key={i} className="mt-8 font-serif text-xl text-gold">{l.slice(4)}</h3>);
    else if (l.startsWith("## ")) out.push(<h2 key={i} className="mt-2 font-serif text-3xl text-warmwhite lg:text-4xl">{l.slice(3)}</h2>);
    else out.push(<p key={i} className="mt-4 font-sans text-sm leading-relaxed text-softgrey">{l}</p>);
  });
  return out;
}

export default function Legal({ type }) {
  const { settings } = useSettings();
  const content = settings?.legal?.[type] || "";

  return (
    <div className="min-h-screen bg-obsidian px-6 pt-32 pb-24 lg:px-10" data-testid={`legal-${type}`}>
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <Eyebrow>Legal</Eyebrow>
          <div className="mt-5">{content ? render(content) : <h1 className="font-serif text-4xl text-warmwhite">{TITLES[type]}</h1>}</div>
        </Reveal>
      </div>
    </div>
  );
}
